export default __webpack_public_path__ + "static/media/electricalLamp.3619cf8e.jpg";